// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/login": [6],
		"/monitor": [7,[2]],
		"/monitor/prueba/[dorsal]": [8,[2]],
		"/panel": [9,[3]],
		"/panel/admin/balizas": [10,[3,4]],
		"/panel/admin/balizas/edit/[[id]]": [11,[3,4]],
		"/panel/admin/configuracion": [12,[3,4]],
		"/panel/admin/entradas": [13,[3,4]],
		"/panel/admin/eventos": [14,[3,4]],
		"/panel/admin/obstaculos": [15,[3,4]],
		"/panel/admin/pruebas": [16,[3,4]],
		"/panel/adultos": [17,[3]],
		"/panel/equipos": [18,[3]],
		"/panel/participaciones": [19,[3]],
		"/panel/reservas": [20,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);